export default __webpack_public_path__ + "static/media/34.0419d5f2.jpg";